module.exports = __webpack_public_path__ + "img/all-good.cbb66321.svg";